export default __webpack_public_path__ + "static/media/ideal.817ca926.png";